export const priceLabelToNumber = (pricelabel = '') => {
  let price = pricelabel
  if (!price) return 0
  if (typeof price === 'number') return price
  price = price.replace(/[-£,$]/g, '')
  if (price.includes('p') > -1) {
    price = price.replace(/p/gi, '')
    price = Math.round(price)
    price = price.length === 1 ? `0${price}` : price
    price = `0.${price}`
  }
  return !Number.isNaN(parseFloat(price)) ? parseFloat(price) : 0
}



// WEBPACK FOOTER //
// ./shared/util/price/index.js